<template>
  <layout-content-vertical-nav
    :nav-menu-items="is_corporate_master ? navMenuItemsMaster : navMenuItems"
  >
    <slot></slot>

    <!-- Slot: Navbar -->
    <template
      #navbar="{ isVerticalNavMenuActive, toggleVerticalNavMenuActive }"
    >
      <!-- navbar componente -->
      <div
        class="navbar-content-container"
        :class="{ 'expanded-search': shallShowFullSearch }"
      >
        <!-- Left Content: Search -->
        <div class="d-flex align-center">
          <v-icon
            v-if="$vuetify.breakpoint.mdAndDown"
            class="me-3"
            @click="toggleVerticalNavMenuActive"
          >
            {{ icons.mdiMenu }}
          </v-icon>
        </div>

        <div
          :class="`w-full d-flex align-center ${
            is_assist_mode ? 'justify-space-between' : 'justify-end'
          }`"
        >
          <v-tooltip>
            <template v-slot:activator="{ on }">
              <span
                v-if="is_assist_mode"
                v-on="on"
                class="text--primary px-4 py-2 rounded-lg d-flex align-center success"
              >
                <v-icon class="mr-1" style="color: white">
                  {{ icons.mdiInformation }}
                </v-icon>
                Estás en modo asistido
              </span>
            </template>
            <span class="top-10">
              Las acciones realizadas quedarán registradas
            </span>
          </v-tooltip>

          <!-- Right Content: I18n, Light/Dark, Notification & User Dropdown -->
          <div class="d-flex align-center right-row">
            <!-- <AppBarCorporateID /> -->
            <app-bar-i18n v-if="!false" />
            <app-bar-theme-switcher class="mx-4" />
            <app-bar-user-menu />
          </div>
        </div>
      </div>
    </template>

    <!-- Slot: Footer -->
    <template #footer>
      <div class="d-flex justify-space-between flex-wrap">
        <span>
          <a
            href="https://ridery.app"
            class="text-decoration-none fontUrbanist font-weight-bold"
            target="_blank" rel="noopener noreferrer"
            >Ridery</a
          ><span class="d-inline">
            &copy; {{ $t("All rights reserved") }}</span
          ></span
        >
        <div class="align-center d-flex">
          <span>Hecho en Venezuela con</span>
          <v-icon class="ms-2" style="color: #3bd4ae !important">
            {{ icons.mdiHeartOutline }}
          </v-icon>
        </div>
      </div>
    </template>
  </layout-content-vertical-nav>
</template>

<script>
import AppBarThemeSwitcher from "@core/layouts/components/app-bar/AppBarThemeSwitcher.vue";

import LayoutContentVerticalNav from "@/@core/layouts/variants/content/vertical-nav/LayoutContentVerticalNav.vue";
import navMenuItems from "@/navigation/vertical";
import navMenuItemsMaster from "@/navigation/master";

// App Bar Components
import AppBarSearch from "@core/layouts/components/app-bar/AppBarSearch.vue";
import AppBarUserMenu from "@/components/AppBarUserMenu.vue";
import AppBarI18n from "@core/layouts/components/app-bar/AppBarI18n.vue";

import { mdiMenu, mdiHeartOutline, mdiInformation } from "@mdi/js";

import { getVuetify } from "@core/utils";

// Search Data
import appBarSearchData from "@/assets/app-bar-search-data";

import { ref, watch } from "vue";
import AppBarCorporateID from "@/@core/layouts/components/app-bar/AppBarCorporateID.vue";

import { mapActions, mapState } from "vuex";

export default {
  components: {
    LayoutContentVerticalNav,

    // App Bar Components
    AppBarSearch,
    AppBarUserMenu,
    AppBarThemeSwitcher,
    AppBarI18n,
    AppBarCorporateID,
  },
  setup() {
    const $vuetify = getVuetify();

    // Search
    const appBarSearchQuery = ref("");
    const shallShowFullSearch = ref(false);
    const maxItemsInGroup = 5;
    const totalItemsInGroup = ref({
      pages: 0,
      files: 0,
      contacts: 0,
    });
    watch(appBarSearchQuery, () => {
      totalItemsInGroup.value = {
        pages: 0,
        files: 0,
        contacts: 0,
      };
    });

    // NOTE: Update search function according to your usage
    const searchFilterFunc = (item, queryText, itemText) => {
      if (item.header || item.divider) return true;

      const itemGroup = (() => {
        if (item.to !== undefined) return "pages";
        if (item.size !== undefined) return "files";
        if (item.email !== undefined) return "contacts";

        return null;
      })();

      const isMatched =
        itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) >
        -1;

      if (isMatched) {
        if (itemGroup === "pages") totalItemsInGroup.value.pages += 1;
        else if (itemGroup === "files") totalItemsInGroup.value.files += 1;
        else if (itemGroup === "contacts")
          totalItemsInGroup.value.contacts += 1;
      }

      return (
        appBarSearchQuery.value &&
        isMatched &&
        totalItemsInGroup.value[itemGroup] <= maxItemsInGroup
      );
    };

    // ? Handles case where in <lg vertical nav menu is open and search is triggered using hotkey then searchbox is hidden behind vertical nav menu overlaty
    const handleShallShowFullSearchUpdate = (
      isVerticalNavMenuActive,
      toggleVerticalNavMenuActive
    ) => {
      if ($vuetify.breakpoint.mdAndDown && isVerticalNavMenuActive) {
        toggleVerticalNavMenuActive();
      }
    };

    return {
      navMenuItems,
      navMenuItemsMaster,
      handleShallShowFullSearchUpdate,

      // Search
      appBarSearchQuery,
      shallShowFullSearch,
      appBarSearchData,
      searchFilterFunc,

      icons: {
        mdiMenu,
        mdiHeartOutline,
        mdiInformation,
      },
    };
  },
  computed: {
    ...mapState("auth", ["user", "is_corporate_master", "is_assist_mode"]),
  },
};
</script>

<style lang="scss" scoped>
.navbar-content-container {
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-grow: 1;
  position: relative;
}

// ? Handle bg of autocomplete for blured appBar
.v-app-bar.bg-blur {
  .expanded-search {
    ::v-deep .app-bar-autocomplete-box div[role="combobox"] {
      background-color: transparent;
    }

    > .d-flex > button.v-icon {
      display: none;
    }

    // ===

    & > .right-row {
      visibility: hidden;
      opacity: 0;
    }

    ::v-deep .app-bar-search-toggler {
      visibility: hidden;
    }
  }
}
</style>
